import { atom } from "jotai";

import { LoadingAtom } from "@/states/loading/types";

export const loadingAtom = atom<LoadingAtom>({
  tasks: [],
});
